import { ROLE } from "@/providers/AuthorizationProvider/types";
import useCapabilities from "@/hooks/useCapabilities";

/** HQ staff see PGA National copy; campus/portal staff see university staff copy. */
export function useUniversityEmailPreviewForStaffCopy() {
  const { hasRole } = useCapabilities();
  const isEducationHq = hasRole(ROLE.EDUCATION_ADMIN) || hasRole(ROLE.GLOBAL_ADMIN);

  return !isEducationHq;
}
